import { FC } from 'react';

import { Motivation } from 'shared/components/Motivation';

interface IMotivationContainerProps {
  url: string;
  isBottom?: boolean;
  onClick: (buttonName: string) => void;
}

export const MotivationContainer: FC<IMotivationContainerProps> = ({ isBottom, url, onClick }) => {
  return <Motivation isBottom={isBottom} url={url} onClick={onClick} />;
};
